import {
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  LoginResponse,
  VendorOnboardingResponse,
  VendorRegistrationData,
  VendorRegistrationPayload,
} from '@/types/auth.types';
import { httpApiClient, rawAxiosApi } from '@/lib/httpClient';
import { MyVendorProfile, VendorLookupResponse } from '@/types/tenant.types';
import { LoginPayload } from '@/schemas/login.schema';
import { OnboardingData } from '@/schemas/onboarding.schema';

export const authAPI = {
  login: async (payload: LoginPayload): Promise<LoginResponse> => {
    const { data } = await rawAxiosApi.post<LoginResponse>('/auth/vendor/login', payload);
    return data;
  },
  forgotPassword: async (payload: ForgotPasswordPayload): Promise<ForgotPasswordResponse> => {
    const { data } = await rawAxiosApi.post<ForgotPasswordResponse>(
      '/auth/vendor/forgot-password',
      payload
    );
    return data;
  },

  getProfile: async (): Promise<MyVendorProfile["data"]> => {
    const { data } = await httpApiClient.get('/auth/vendor/me');
    return data;
  },

  logout: async (): Promise<void> => {
    await httpApiClient.post('/auth/vendor/logout');
  },

  register: async (payload: VendorRegistrationPayload): Promise<VendorRegistrationData> => {
    const { data } = await rawAxiosApi.post<VendorRegistrationData>(
      '/auth/vendor/register',
      payload
    );
    return data;
  },

  vendorLookup: async (payload: { email: string }): Promise<VendorLookupResponse> => {
    const { data } = await rawAxiosApi.get<VendorLookupResponse>('/auth/vendor/lookup', { params: payload });
    return data;
  },
  completeOnboarding: async (payload: OnboardingData): Promise<VendorOnboardingResponse> => {
    const { data } = await httpApiClient.post<VendorOnboardingResponse>(
      '/auth/vendor/complete-onboarding',
      payload
    );
    return data;
  },
};
